import React, { useMemo, useEffect } from "react";
import "@ant-design/compatible/assets/index.css";
import debounce from 'lodash.debounce';
import { AutoComplete, Form } from "antd";

const AutoCompleteFormItem = ({
  autoComplete,
  dataSource,
  formItem,
  placeholder,
}) => {
  const valueKey = formItem.name;
  const dataOptions = dataSource
    ? dataSource.map((d) => {
      return { value: d[`${valueKey}`] };
    })
    : [];
  const debouncedChangeHandler = useMemo(
    () => debounce(autoComplete.autoCompleteOneChange, 300),
    [],
  );

  useEffect(() => {
    return () => {
      debouncedChangeHandler.cancel();
    }
  }, []);

  return (
    <Form.Item
      label={formItem.label}
      name={formItem.name}
      rules={[
        {
          required: true,
          message: formItem.message,
        },
      ]}
    >
      <AutoComplete
        options={dataOptions}
        placeholder={placeholder}
        filterOption={(inputValue, option) =>
          option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        onChange={debouncedChangeHandler}
        onSelect={autoComplete.autoCompleteOneSelect}
        allowClear={true}
      />
    </Form.Item>
  );
};

export default AutoCompleteFormItem;
